import React, { useState } from 'react';
import axios from 'axios';
import PageWrapper from '../../component/PageWrapper';
import { API_JAVA } from '../../config';
import { useTranslation } from "react-i18next";
import ErrorModal from "../../component/ErrorModal";
import SuccessModal from "../../component/SuccessModal";
import { toBeInTheDocument } from '@testing-library/jest-dom/matchers';

const GetSDKForm = () => {
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [errorMessage, setErrorMessage] = useState(null); // Стейт для ошибки
    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrorMessage(''); // Сбрасываем ошибку перед новым запросом
        setSuccessMessage('');
        try {
          
            const response = await axios.post(`${API_JAVA}/sdk-user/generate-link`, { email });
            setSuccessMessage("getSDKForm.success");

        } catch (error) {
            // const errorMessage = error.response.data;   //оброботать на бэке исключений
            // setErrorMessage(error.response.data.detail)
            if (error.response && error.response.status === 404) {
                setErrorMessage("getSDKForm.emailNotFound");
            } else {
                setErrorMessage("getSDKForm.errorResponse");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <PageWrapper title={t("getSDKForm.getSDK")}>
            {/* Контейнер для ErrorModal с отступом */}
            {errorMessage && (
                <div style={{ marginBottom: '15px' }}>
                    <ErrorModal errorMessage={errorMessage} />
                </div>

            )}
            {successMessage && (
              <div style={{marginBottom: '15px'}}>
                  <SuccessModal successMessage={successMessage} />
              </div>
            )}
            <div className='get-sdk-form'>
                <label>Email:</label>
                <input
                    className='get-sdk-input'
                    // placeholder='example@example.kz'
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <button className='new-blue-btn' onClick={handleSubmit} disabled={loading}>
                    {loading ? t("getSDKForm.sendEmail") : t("getSDKForm.getURL")}
                </button>
            </div>
        </PageWrapper>
    );
};

export default GetSDKForm;
